const avisoGridConfig = {
  idField: "idAviso",
  columns: [
    { header: "Referência", field: "REFERENCIA" },
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default avisoGridConfig;